// Relative by default so requests go through the portal's own domain
// (proxied to the API by vercel.json in production, and by the
// package.json "proxy" dev-server setting in local development).
// Set REACT_APP_API_BASE_URL only to point at a different API host.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const getStoredUser = () => {
  const raw = localStorage.getItem('user');
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const getToken = () => localStorage.getItem('token');

export const getAuthHeaders = (includeJson = false) => {
  const token = getToken();
  const headers = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  if (includeJson) {
    headers['Content-Type'] = 'application/json';
  }

  return headers;
};

export const getCustomerId = (user) => {
  if (!user) return null;
  if (typeof user.customerName === 'string') return user.customerName;
  if (user.customerName?._id) return user.customerName._id;
  if (user.customer?._id) return user.customer._id;
  if (typeof user.customerId === 'string') return user.customerId;
  return null;
};
